import _ from "lodash";
/**-- external -- */
import React, { useState, useMemo } from "react";
import { SearchInput } from "@toddle-edu/ds-web";

/**-- internal -- */
import { useI18n } from "Hooks";
import { SEARCH_INPUT_DEBOUNCE_TIME } from "Constants";

const SearchWithDeBounce = ({
  testId,
  onChangeSearchText,
  isLearningCoursesFeed,
}) => {
  const [searchText, setSearchText] = useState("");
  const localTestId = `${testId}-searchWithDeBounce`;

  const { t } = useI18n(["common"]);

  const onChangeSearchTextWithDeBounce = useMemo(() => {
    return _.debounce(onChangeSearchText, SEARCH_INPUT_DEBOUNCE_TIME);
  }, [onChangeSearchText]);

  const onChangeSearchTextLocal = value => {
    setSearchText(value);
    onChangeSearchTextWithDeBounce(value);
  };

  const searchPlaceholder = isLearningCoursesFeed
    ? t("course:search_courses")
    : t("common:search_classes");

  return (
    <SearchInput
      size={"medium"}
      testId={localTestId}
      placeholder={searchPlaceholder}
      onChange={onChangeSearchTextLocal}
      value={searchText}
    />
  );
};

export default SearchWithDeBounce;
